// CountdownTimer.jsx
import React, { useEffect, useState } from "react";

function fmt(secs) {
  const s = Math.max(0, secs | 0);
  const hh = String(Math.floor(s / 3600)).padStart(2, "0");
  const mm = String(Math.floor((s % 3600) / 60)).padStart(2, "0");
  const ss = String(s % 60).padStart(2, "0");
  return `${hh}:${mm}:${ss}`;
}

export default function CountdownTimer({ target }) {
  const [remaining, setRemaining] = useState(0);

  useEffect(() => {
    if (!target) return;
    const t = target?.toDate?.() || new Date(target);
    const tick = () =>
      setRemaining(Math.max(0, Math.floor((t.getTime() - Date.now()) / 1000)));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [target]);

  let istText = "";
  if (target) {
    const t = target?.toDate?.() || new Date(target);
    istText = new Intl.DateTimeFormat("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "Asia/Kolkata",
    }).format(t);
  }

  return (
    <div className="rounded-2xl bg-slate-800/70 px-4 py-2 text-yellow-400 font-mono">
      <div>Draw in: {fmt(remaining)}</div>
      <div className="text-xs text-yellow-300 text-right">
        Draw @ {istText} (GMT+5:30)
      </div>
    </div>
  );
}
